import type { Expand } from "@pdfking/tfunc"
import { Init } from "@pdfking/reactivity/preact"
import { scan } from "@pdfking/rfunc"
import importer from "@pdfking/translations/importer"
import manifest from "@pdfking/translations/manifest"
import { settings_get } from "../state/settings"

type TranslationLibrary = Record<string, string>
type Translations = Expand<Record<string, TranslationLibrary>>

const get_language = (lang?: string): string =>
  lang || (settings_get("settings", "language") as string) || manifest.language

export const get_translations = (library: string, lang?: string) => {
  const language = get_language(lang)
  const imp = importer[language][library]
  return imp().then((m: { default: TranslationLibrary }) => m.default)
}

export default (names?: string | string[], lang?: string): Translations => {
  const libraries = names || manifest.libraries
  const data: Record<string, any> = {}
  scan((library: string) => {
    data[library] = {}
  }, libraries)

  const instance: any = Init({ data })
  scan(
    (library: string) =>
      get_translations(library, lang).then(
        (res: TranslationLibrary) => (instance[library] = res)
      ),
    libraries
  )
  return instance
}
